<template lang="html">
    <div class="sign-up-user-term">
        <div class="sign-up-user-term__container">
            <div class="sign-up-user-term__container-checkbox"
                 :class="{ 'sign-up-user-term__container-checkbox--danger': invalidField }">
                <input class="sign-up-user-term__container-checkbox-input" type="checkbox" id="politicas"
                       value="politicas" v-model="termChecked">

                <label v-if="isNew"
                       class="sign-up-user-term__container-checkbox-label sign-up-user-term__container-checkbox-label--new"
                       for="politicas">
                    Estou de acordo referente a utilização dos serviços no Cartão conforme o
                    <a href="https://filoo.com.br/termos-de-uso/" target="_blank">
                        Termos de Uso
                    </a>,
                    <a href="https://filoo.com.br/termo-de-consentimento/" target="_blank">
                        Termo de Consentimento
                    </a>
                    e
                    <a href="https://filoo.com.br/politica-de-privacidade/" target="_blank">
                        Política de Privacidade
                    </a>.
                </label>

                <label v-else class="sign-up-user-term__container-checkbox-label" for="politicas">
                    Sim, concordo com os
                    <a href="https://filoo.com.br/termos-de-uso/" target="_blank">
                        Termos de Uso
                    </a>
                    e
                    <a href="https://filoo.com.br/politica-de-privacidade/" target="_blank">
                        Política de Privacidade
                    </a>.
                    Também autorizo o tratamento dos meus dados pessoais para receber ofertas
                    e comunicações, conforme especificado no
                    <a href="https://filoo.com.br/termo-de-consentimento/" target="_blank">
                        Termo de Consentimento
                    </a>.
                </label>
            </div>

            <div v-if="invalidField" class="con-text-validation span-text-validation-danger">
                <span class="span-text-validation">{{ alertMessage }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import mixins from "@/mixins/mixins.js"

export default {
    name: 'SignUpUserTerm',

    mixins: [mixins],

    props: {
        error: {
            type: Boolean,
            default: false
        },
        checked: {
            type: Boolean,
            default: false
        },
        isNew: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            termChecked: false,
            invalidField: false,
            alertMessage: null
        }
    },

    watch: {
        error() {
            this.checkTermChecked()
        },
        checked(val) {
            this.termChecked = val
        },
        termChecked(val) {
            if (val) {
                this.alertMessage = null
                this.invalidField = false
            }

            this.$emit('set:userTerm', this.termChecked)
        }
    },

    mounted() {
        if (this.checked) {
            this.termChecked = this.checked
        }
    },

    methods: {
        checkTermChecked() {
            if (!this.termChecked || this.error) {
                this.alertMessage = 'O aceite do termo de consentimento é obrigatório.'
                this.invalidField = true
            }

            this.$emit('set:userTerm', this.termChecked)
            return this.termChecked;
        }
    }
}
</script>

<style lang="scss" scoped>
.sign-up-user-term {
    &__header {
        &-title {
            font-size: 1.5rem;

            @media screen and (min-width: 1200px) {
                font-size: 2rem;
            }
        }
    }

    &__container {
        &-checkbox {
            $checkbox: &;
            position: relative;

            &-input {
                opacity: 0;
                position: absolute;

                &:checked {
                    & + #{$checkbox} {
                        &-label:before {
                            background-color: #FA961E;
                            border-color: darken(#FA961E, 10%);
                        }

                        &-label:after {
                            border-bottom: 3px solid #FFF;
                            border-left: 3px solid #FFF;
                            width: 12px;
                            height: 8px;
                            transform: rotate(-45deg);
                            top: 6px;
                            left: 4px;
                            opacity: 1;
                        }
                    }
                }
            }

            &-label {
                position: relative;
                padding-left: 1.75rem;

                &:before,
                &:after {
                    content: '';
                    cursor: pointer;
                    left: 0rem;
                    height: 20px;
                    width: 20px;
                    position: absolute;
                    top: 5px;
                    transition: all ease-in-out .2s;
                }

                &:before {
                    background-color: #FFF;
                    border: 1px solid #999;
                    border-radius: .25rem;
                    position: absolute;
                    top: 2px;
                }

                &:after {
                    border-bottom: 0px solid #FFF;
                    border-left: 0px solid #FFF;
                    opacity: 0;
                }

                &--new {
                    font-size: .875rem;

                    @media #{$md-and-up} {
                        font-size: 1rem;
                    }

                    a {
                        color: black !important;
                        text-decoration: underline;
                    }
                }
            }

            &--danger {
                border: 1px solid rgba(var(--vs-danger), 1);
                margin: calc(-.5rem - 1px);
                padding: .5rem;
            }
        }
    }

    .con-text-validation {
        margin-top: .5rem;
    }
}
</style>
